import { NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input, OnChanges } from '@angular/core';

import { EventModel, EventScoreboard, SnookerScore } from '@frontend/sports/betting-offer/feature/model';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';

import { EventTimerComponent } from '../../timers/event-timer.component';
import { BestOfComponent } from './best-of/best-of.component';
import { ScoreCardComponent } from './score-card.component';
import { ScoreboardParticipantComponent } from './scoreboard-participant.component';

@Component({
    selector: 'ms-snooker-scoreboard',
    templateUrl: 'snooker-scoreboard.component.html',
    imports: [NgTemplateOutlet, EventTimerComponent, BestOfComponent, ScoreCardComponent, ParticipantImageComponent, ScoreboardParticipantComponent],
})
export class SnookerScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @Input() isNewEDPScoreboard = false;

    @HostBinding('class') className = 'snooker';
    score: SnookerScore;
    showPoints = false;
    periodName = '';

    ngOnChanges(): void {
        this.score = this.event.scoreboard.getScore<SnookerScore>()!;
        this.showPoints = !!(this.score.participant1 > 0 || this.score.participant2 > 0);
        this.periodName = this.event.scoreboard.period?.name || '';
    }
}
